import React, { createContext, useContext, useState, useCallback, useRef } from 'react';

// Lightweight toast system. Any consumer can `addToast({message, icon, type, duration})`;
// the ToastViewport (mounted once at app level) renders the live queue.

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextIdRef = useRef(1);

  const addToast = useCallback((opts) => {
    if (!opts || !opts.message) return null;
    const id = nextIdRef.current++;
    const toast = {
      id,
      message:  opts.message,
      icon:     opts.icon ?? '',
      type:     opts.type ?? 'info',          // 'info' | 'success' | 'warn' | 'danger'
      duration: opts.duration ?? 4000,
    };
    setToasts((prev) => [...prev, toast]);
    if (toast.duration > 0) {
      setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id));
      }, toast.duration);
    }
    return id;
  }, []);

  const dismissToast = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ toasts, addToast, dismissToast }}>
      {children}
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be inside ToastProvider');
  return ctx;
}
